import { Injectable } from '@angular/core';
import { AutenticacaoInterface, ImpersonacaoSessaoInterface } from '../../_interfaces/autenticacao.interface';
import { Utilitarios } from '../../_common/utilitarios.common';

@Injectable({
  providedIn: 'root'
})
export class ImpersonacaoService {
  podeEmular(): boolean {
    return new Utilitarios().IsUsuarioAdminReal();
  }

  obterSessao(): ImpersonacaoSessaoInterface {
    return new Utilitarios().RetornarImpersonacao();
  }

  estaEmulando(): boolean {
    return !!this.obterSessao();
  }

  iniciar(emulado: AutenticacaoInterface): void {
    const util = new Utilitarios();
    const atual = util.RetornarLocalStorageAutenticacao();

    if (!atual?.dsToken) {
      throw new Error('Sessão administrativa inválida.');
    }

    if (!util.RetornarAutenticacaoOriginal()) {
      util.GravarAutenticacaoOriginal(JSON.stringify(atual));
    }

    const original = util.RetornarAutenticacaoOriginal() || atual;
    const overlay: AutenticacaoInterface = {
      ...emulado,
      dsToken: original.dsToken,
      expires: original.expires,
      flSenhaTemporaria: original.flSenhaTemporaria
    };

    util.GravarItemLocalStorageAutenticacao(JSON.stringify(overlay));
    util.GravarImpersonacao({
      id: emulado.id,
      dsLogin: emulado.dsLogin,
      dsNome: emulado.dsNome
    });

    Utilitarios.IsAdmin = false;
    Utilitarios.Roles = [];
    this.recarregarPainel();
  }

  encerrar(): void {
    const util = new Utilitarios();
    const original = util.RetornarAutenticacaoOriginal();

    if (original) {
      util.GravarItemLocalStorageAutenticacao(JSON.stringify(original));
    }

    util.RemoverAutenticacaoOriginal();
    util.RemoverImpersonacao();
    this.recarregarPainel();
  }

  private recarregarPainel(): void {
    window.location.hash = '#/dashboard';
    window.location.reload();
  }
}
